const datahappy=[
    {
      "id": 2,
      "titulo": "Dia Mundial da Criança",
      "data": "20/11/2023",
      "hora": "07:00"
    },
    {
      "id": 3,
      "titulo": "Dia Nacional da Consciência Negra",
      "data": "20/11/2023",
      "hora": "07:00"
    },
    {
      "id": 4,
      "titulo": "Dia de Ação de Graças",
      "data": "23/11/2023",
      "hora": "07:00"
    },
    {
      "id": 5,
      "titulo": "Black Friday",
      "data": "24/11/2023",
      "hora": "06:00"
    },
    {
      "id": 6,
      "titulo": "Cyber Monday",
      "data": "27/11/2023",
      "hora": "00:00"
    },
    {
      "id": 7,
      "titulo": "Dia Internacional do Voluntariado",
      "data": "05/12/2023",
      "hora": "06:00"
    },
    {
      "id": 8,
      "titulo": "Natal",
      "data": "25/12/2023",
      "hora": "00:00"
    },
    {
      "id": 9,
      "titulo": "Ano Novo",
      "data": "01/01/2024",
      "hora": "00:00"
    },
  ]
  export default datahappy;